var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 15.69h7.144c1.668 0 2.666-.97 2.666-2.631v-.944l2.584 2.188c.273.225.574.382.855.382.601 0 .998-.444.998-1.08V6.537c0-.636-.397-1.08-.998-1.08-.28 0-.581.157-.855.383L14.58 8.027v-.936c0-1.668-.998-2.639-2.666-2.639H4.771c-1.593 0-2.667.97-2.667 2.639v5.968c0 1.66.999 2.631 2.667 2.631zm.192-1.025c-1.121 0-1.757-.581-1.757-1.77V7.248c0-1.183.636-1.764 1.757-1.764h6.76c1.115 0 1.758.581 1.758 1.764v5.647c0 1.189-.643 1.77-1.757 1.77H4.962zm12.715-1.292l-3.097-2.557v-1.49l3.097-2.556c.061-.048.102-.076.164-.076.082 0 .116.062.116.158v6.439c0 .096-.034.164-.116.164-.062 0-.103-.04-.164-.082z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "static/media/cam-on.b61d141a.svg";
export { SvgCamOn as ReactComponent };